<div @tooltip class="adf-tooltip-card" [style.width.px]="width">
    <img *ngIf="image " [src]="image" [width]="width" alt="{{text}}">
    <hr *ngIf="image" />
    <p *ngIf="text">{{text}}</p>
    <div *ngIf="htmlContent" [innerHTML]="sanitizedHtmlContent()" class="adf-tooltip-card-content"></div>
</div>
